
import React from 'react';
import { BOOKING_TYPE } from '../../../constants';

/**
 * @module Modals/BulkBookUnbookModal/FilterStep
 */
/**
 * @typedef {object} props
 * @property {object} dateTime
 * @property {Array} selectedCompetitions
 * @property {object} errorSummary
 * @property {Function} changeDateTime
 * @property {Function} isFormComplete
 * @property {Function} chooseAction
 */

/**
 * @param {props} props
 * @returns {view}
 */
const FilterStep = ({
  dateTime,
  selectedCompetitions,
  errorSummary,
  changeDateTime,
  isFormComplete,
  chooseAction,
}) => (
  <>
    <div className="dialog__content">
      <div className="filter__field">
        <label className="filter__field-label">Competitions</label>
        <div style={{ paddingLeft: '5px', fontSize: '.7rem'}}>
          {selectedCompetitions.length > 0
            ? selectedCompetitions.map((competition) => competition.name).join(', ')
            : 'All'}
        </div>
      </div>
      <div className="filter" style={{ paddingTop: 0}}>
        <div className="filter__field">
          <label className="filter__field-label">From</label>
          <div className="d-flex">
            <input
              type="date"
              className="filter__field-input"
              value={dateTime.fromDate}
              onChange={(e) => changeDateTime('fromDate', e.target.value)}
            />
            <input
              type="time"
              className="filter__field-input m-l-10"
              value={dateTime.fromTime}
              onChange={(e) => changeDateTime('fromTime', e.target.value)}
            />
          </div>
        </div>
        <div className="filter__field">
          <label className="filter__field-label">To</label>
          <div className="d-flex">
            <input
              type="date"
              className="filter__field-input"
              value={dateTime.toDate}
              onChange={(e) => changeDateTime('toDate', e.target.value)}
            />
            <input
              type="time"
              className="filter__field-input m-l-10"
              value={dateTime.toTime}
              onChange={(e) => changeDateTime('toTime', e.target.value)}
            />
          </div>
        </div>
      </div>
      {errorSummary && (
        <>
          {Object.values(errorSummary).map((elem, index) => (
            <React.Fragment key={index}>
              {elem}
            </React.Fragment>
          ))}
        </>
      )}
    </div>
    <div className="dialog__btn-wrap">
      <button
        id="bookAll_BulkBookUnbookModal"
        type="button"
        className="btn btn-secondary"
        disabled={!isFormComplete()}
        onClick={chooseAction.bind(this, BOOKING_TYPE.BOOK)}
      >
        Book All
      </button>
      {' '}
      <button
        id="unbookAll_BulkBookUnbookModal"
        type="button"
        className="btn btn-secondary m-l-10"
        disabled={!isFormComplete()}
        onClick={chooseAction.bind(this, BOOKING_TYPE.UNBOOK)}
      >
        Unbook All
      </button>
    </div>
  </>
);

export default FilterStep;
